<!--
 * @Descripttion: 育儿音频
 * @Author: hezizhao
 * @Date: 2021-01-12 15:27:02
 * @LastEditors: 李嘉辉 LiJiaHui0908
 * @LastEditTime: 2022-07-27 15:44:20
-->
<template>
  <div class="article">
    <van-list
        v-model="pageParams.loading"
        :error.sync="pageParams.error"
        :finished="pageParams.audioFinished"
        :finished-text="bottomText"
        error-text="请求失败，点击重新加载"
        @load="getDataList"
    >
      <div class="article_list">
        <div v-for="(item,index) in audioList" :key="index" class="article_box">
          <div class="article_box_details" @click="onLinkTap(item,index)">
            <div class="title">{{item.name}}</div>
            <div class="time">
              <p>
                <span class="listen">
                  <img src="../../../assets/images/icon/audio_listen1.png" />
                  {{item.startTime|audioPlayDate}}
                </span>
                <span>
                  <img src="../../../assets/images/icon/audio_time.png" />
                  {{item.durationStr || "00:00"}}
                </span>
                <span>
                  <img src="../../../assets/images/icon/audio_play.png" />
                  {{fomatterNum(item.watchNum) || 0}}
                </span>
              </p>
            </div>
          </div>
          <div class="audio">
            <img class="bg_img" :src="item.coverUrl" />
            <img
                :class="item.isPlay?'playing':''"
                :src="item.isPlay?play:off"
                class="play"
                @click="startPlay(item,index)"
            />
          </div>
        </div>
      </div>
    </van-list>
    <my-music

        v-if="audioList.length>0"
        ref="musicAudio"
        :audioParams="audioParams"
        :playTime="playTime"
        @addPalyNum="addPalyNum"
        @pauseaudioparams="PauseaudioParams"
        @playaudioparams="PlayaudioParams"
        @senDetail="senDetail"
        @audio-end="audioEvenTend"
    ></my-music>
  </div>
</template>

<script>
//混入音频公共逻辑
import {audioMixins} from "@/minxs/audio.js";
import API_ from "@/utils/axiosApi/audioApi.js"; //api事件
//音频组件
import myMusic from "@/components/contents/parentingAudio/parentingAudio_1.0.vue";
import {fomatterNum, getCookie, setCookie, TestUserAgent,} from "@/assets/js/common.js"; //工具类
import {setTimeout} from 'timers';

export default {
  data() {
    return {
      //当前播放音频id
      playId: null,

      type: "audio",
      // 播放时间
      playTime: 0,
      //列表数据
      audioList: [],
      //用户数据
      userInfo: {},
      //点赞状态
      likeState: false,
      //收藏状态
      cllectState: false,
      // 到底部提示语
      bottomText: "",
      // 分页参数
      pageParams: {
        page: 1,
        size: 25,
        error: false,
        loading: false,
        audioFinished: false,
      },
      audioParams: {}, //传递音频的整体大对象（title、img、audioUrl）
      playIndex: 0,
      sensorsFlag: true, // 埋点
    };
  },
  mixins: [audioMixins],

  components: {
    myMusic,
  },

  props: {
    ABtest: {
      type: String,
      default: "",
    },
    isAudioChild: {
      type: Boolean,
    },
    isPlayAudioChild: {
      type: Boolean,
    },
  },

  activated() {
    const playStatus = sessionStorage.getItem("currentPlayStatus") || "";
    const {page, id} = this.$store.state.recordAudio;
    if (page != "" && id !== "" && playStatus !== "") {
      this.pageParams.loading = true;
      this.pageParams.audioFinished = false;
      this.audioList = [];
      let pageArr = [];

      let i = 1;
      while (i <= page) {
        pageArr.push(i);
        i++;
      }

      let parama = pageArr.map((res) => {
        return new Promise((reslove) => {
          this.pageParams.page = res;
          this.getDataList("", (k) => {
            reslove(k);
          });
        });
      });

      Promise.all(parama)
        .then((result) => {
          let newaudioList = [];
          let n = 0;
          while (n <= result.length - 1) {
            newaudioList = newaudioList.concat(result[n].data.data);
            n++;
          }

            this.audioList = newaudioList;
            var {audioTime, id} = this.$store.state.recordAudio;
            const _index = this.audioList.findIndex((res) => res.id === id);
            this.playIndex = _index;
            if (playStatus === "1") {
              this.playTime = audioTime;
              this.audioList[_index].isPlay = true;
            } else {
              this.audioList[_index].isPlay = false;
            }
            this.$nextTick(() => {
              setTimeout(() => {
                this.playTime = audioTime;
              }, 300);
            });
            this.audioParams = this.audioList[_index];
          })

          .catch(function (r) {
            console.log(r);
          });
    }
  },
  mounted() {
    //   获取用户信息
    this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
  },
  methods: {
    addPalyNum() {
      setTimeout(() => {
        let id = this.audioParams.id;
        let time=this.audioParams.durationStr.split(":")[0]*60+this.audioParams.durationStr.split(":")[1]*1-1
        const percent = Math.round(this.$refs.musicAudio.current / time * 10000) / 10000.00
        // if (this.playId == id) return;
        sensors.track("Audio_and_video_playback", {
          content_id:String( this.audioParams.id),
          content_title: this.audioParams.title,
          Content_column:"育儿音频",
          length_of_time: time,
          content_topic: "",
          position: 0,
          video_duration: String(this.$refs.musicAudio.current),
          is_finished: percent >= 0.8 ? true : false,
          Shopping_guide_ID: "",
          account_type: "",
        });
        this.playId = id
      }, 200)
    },
    PlayaudioParams(obj) {
      this.audioList.forEach((res) => {
        if (res.id === obj.id) {
          res.isPlay = true;
        }
      });
      this.$forceUpdate();
    },
    PauseaudioParams(obj) {
      this.audioList.forEach((res) => {
        if (res.id === obj.id) {
          res.isPlay = false;
        }
      });
      this.$forceUpdate();
    },
    cancelPlay() {
      this.audioList[this.playIndex].isPlay = false;
      this.$refs.musicAudio.$refs.isStatus = false;
      this.$refs.musicAudio.$refs.player.pause();
    },
    senDetail() {
      this.onLinkTap(this.audioList[this.playIndex], this.playIndex);
    },
    //切换下一个
    audioEvenTend() {
      if (this.playIndex === this.audioList.length - 1) {
        if (this.pageParams.audioFinished) {
          this.playIndex = 0;
        } else {
          this.getDataList(1);
        }
      } else {
        this.playIndex++;
        const {isios} = TestUserAgent();
        if (isios) {
          this.$refs.musicAudio.clearTime();
        }

      }
      this.audioList.forEach((res, i) => {
        if (this.playIndex == i) {
          res.isPlay = true;
        } else {
          res.isPlay = false;
        }
      });

      this.audioParams = this.audioList[this.playIndex];
    },
    startPlay(item, index) {
      // if (!(this.userInfo && this.userInfo.mobile)) {
      //   this.$router.push({
      //   path:
      //       "/phoneLogin?redirect=" +
      //       window.location.origin +
      //       "/calendar?shareFrom=audio",
      //   });
      // } else {

      const {isios} = TestUserAgent();
      if (isios) {
        this.$refs.musicAudio.clearTime();
      } else {
      }
      // this.$refs.musicAudio.clearTime()
      if (!item.isPlay) {
        this.audioParams = item;
        this.addPlay(item.id, index);
      } else {
        this.onLinkTap(item, index);
      }
      this.audioList.forEach((res, i) => {
        if (index == i) {
          res.isPlay = true;
        } else {
          res.isPlay = false;
        }
      });
      this.playIndex = index;
      // }
    },
    /**
     * 获取育儿音频列表数据
     * @type 布尔值为1为循环播放 2 初始化带出当前哪一页 ''初始化数据
     */
    getDataList(type = "", callback) {
      const crmId = this.userInfo ? this.userInfo.crm_id : "";
      API_.getListData(
        {},
        {
          crmId: crmId,
          page: this.pageParams.page,
          size: this.pageParams.size,
        },
        (res) => {
          this.pageParams.loading = false;
          if (res.code == 200) {
            var arrList = res.data.data;
            arrList.forEach((item, index) => {
              //为每一项{}添加一个播放标识 默认为false
              item.isPlay = false;
            });
            this.audioList = this.audioList.concat(arrList);

            $(".van-tabs__content").css("background", "#f2f2f2");
            if (this.pageParams.page == 1) {
              if (res.data.data.length == 0) {
                this.bottomText = "";
                this.$emit("isEmpty", true);
                $(".van-tabs__content").css("background", "#fff");
              } else {
                this.audioParams =
                  this.audioParams && this.audioParams.id
                    ? this.audioParams
                    : res.data.data[0];
                this.audioParams.isPlay = undefined;
              }
            }
            const HASMORE =
              res.data.total == 0 ||
              this.pageParams.page >=
                Math.ceil(res.data.total / this.pageParams.size);
            if (HASMORE) {
              this.pageParams.audioFinished = true;
              this.bottomText = "——已经到底了哦——";
            } else {
              this.pageParams.page += 1;
            }
            // type为1 判断当前播放是否到最后一页
            if (type === 1) {
              if (HASMORE) {
                this.playIndex = 0;
              } else {
                this.playIndex++;
              }
              this.audioParams = this.audioList[this.playIndex];
            }

              if (this.sensorsFlag) {
                this.sensorsFlag = false;
                sensors.track("Parenting_program_PV_UV", {Column: "育儿音频"});
              }
              callback(res);
            } else {
              this.$toast("网络异常");
              this.pageParams.loading = false;
              this.pageParams.error = true;
            }
          }
      );
    },

    // 收听
    addPlay(id, index) {
      const perfectionPlay = sessionStorage.getItem("perfectionPlay");
      if (perfectionPlay == "true") {
        this.audioList[index].orPlay = false;
      }
      if (this.audioList[index].orPlay) return;
      API_.addPlay({}, {id: id}, (res) => {
        if (res.code == 200) {
          var relation = id;
          this.audioList[index].orPlay = true;
          this.audioList[index].play += 1;
          sessionStorage.setItem("perfectionPlay", false);

        } else {
          this.$toast("网络异常");
        }
      });
    },

    // 完成任务
    taskFinish(text, relation, type) {
      var date = Date.parse(new Date());
      var string = "34f9cd73a0044a2e8d47e85de884b8b1300777";
      var taskid = "6";
      var relation = relation;
      var md5 = this.$md5(string + taskid + relation + date);
      var openid = this.getCookie("xmh_openid")
          ? this.getCookie("xmh_openid")
          : this.userInfo.memberChannel[0].account;
      this.$http.post(
          "/taskEventController/finish/xmh",
          {},
          {
            crm_id: this.userInfo.crm_id,
            task_id: "6",
            relation_id: relation,
            open_id: openid,
            timestamp: date,
            rand: md5,
          },
          (res) => {
            if (res.code == "200") {
              var taskfinish = res.data.xyz;
              this.$toast({
                duration: 2000,
                message: text + taskfinish,
                context: this,
              });
            } else {
              if (type == 3) return;
              this.$toast({
                duration: 2000,
                message: type == 1 ? "点赞成功" : "收藏成功",
                context: this,
              });
            }
          }, (err) => {
          }, 'member'
      );
    },
    fomatterNum,
    getCookie,
    setCookie,
  },
};
</script>
<style lang="less" scoped>
@import "../../../assets/less/parenAudio.less";

</style>